import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import v3Image from "../../assets/DomeTurret/g5-dome-ultra.jpg";
import image from "../../assets/product-list-assets/cameras/dome-and-turret/g5-dome-ultra.jpg";
import type { Product } from "../../types";
import { domeTurret } from "../product-groups/cameraSecurity/DomeTurret";
import { domeTurret as productListDomeTurret } from "../product-list-groups/domeTurret";
import { deployment } from "../properties/deployment";
import { outdoorReady } from "../properties/outdoorReady";

export const g5DomeUltra: Product = {
  id: "g5DomeUltra",
  productTitle: "G5 Dome Ultra",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.CamerasNVRs}/uvc-g5-dome-ultra`,
  ],
  storePathParts: {
    productSlug: "uvc-g5-dome-ultra",
    category: UniFiChildCategorySlug.CamerasDomeTurret,
  },
  description: "g5DomeUltra.description.1",
  descriptionMaxWidth: 160,
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: v3Image,
    width: 250,
    height: 182,
  },
  productGroup: domeTurret,
  productListGroup: productListDomeTurret,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: 'Ø63.6 x 68.2 mm\n(Ø2.5 x 2.7")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "2K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: '1/2.4" CMOS' },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "g5DomeUltra.fieldOfView.1",
      },
    },
    {
      propertyId: "nightVision",
      value: { type: "string", value: "20 m (65 ft)" },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "aiRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "cameraAudio",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK06" },
    },
    {
      propertyId: deployment.id,
      value: { type: "string", value: "PoE" },
    },
  ],
};
